import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">平台优势</h2>
          <p className="text-sm text-foreground-500 mt-2">为什么5000万影迷选择8090影视</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
          {featureItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-6 md:p-8 text-center border border-background-200/60">
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mt-4">{item.title}</h3>
              <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}